import * as React from "react";
import {META_DEFAULTS} from "./MetaWrapper";

export const {Provider, Consumer} = React.createContext(
  META_DEFAULTS as any
);
